var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _g3, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyJournaling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 145,
    viewBox: "0 0 267 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 119C75.6995 119 56 99.3005 56 75C56 50.6995 75.6995 31 100 31C124.301 31 144 50.6995 144 75C144 99.3005 124.301 119 100 119Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 143C91.6995 143 72 123.301 72 99C72 74.6995 91.6995 55 116 55C140.301 55 160 74.6995 160 99C160 123.301 140.301 143 116 143Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154 106C127.49 106 106 84.5097 106 58C106 31.4903 127.49 10 154 10C180.51 10 202 31.4903 202 58C202 84.5097 180.51 106 154 106Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151 138C124.49 138 103 116.51 103 90C103 63.4903 124.49 42 151 42C177.51 42 199 63.4903 199 90C199 116.51 177.51 138 151 138Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116 97C91.6995 97 72 77.3005 72 53C72 28.6995 91.6995 9 116 9C140.301 9 160 28.6995 160 53C160 77.3005 140.301 97 116 97Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 256 46)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 46 141)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 61)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 49 0)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 205 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 267 135)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.179 133.388C229.305 136.603 244.173 126.947 247.388 111.821C250.603 96.6952 240.948 81.8267 225.822 78.6116C210.696 75.3964 195.827 85.0521 192.612 100.178C189.397 115.304 199.053 130.173 214.179 133.388Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.179 113.71L205.959 106.127L212.997 116.965L204.939 116.42L203.179 113.71Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.635 92.0541C229.631 90.7584 232.298 91.3255 233.594 93.3207L235.94 96.9335C237.236 98.9287 236.669 101.597 234.674 102.892L232.867 104.065L225.829 93.2272L227.635 92.0541Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.829,
    y: 93.2266,
    width: 12.9231,
    height: 23.6923,
    transform: "rotate(57 225.829 93.2266)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.252 116.239L203.179 113.711L204.938 116.42L202.252 116.239Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.203,
    y: 111.773,
    width: 6.46154,
    height: 1.07692,
    transform: "rotate(57 203.203 111.773)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.283,
    y: 92.9316,
    width: 12.9231,
    height: 1.07692,
    transform: "rotate(57 226.283 92.9316)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.863,
    y: 105.543,
    width: 12.9231,
    height: 1.07692,
    transform: "rotate(57 206.863 105.543)",
    fill: "#D89FEE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131 126C159.719 126 183 102.719 183 74C183 45.2812 159.719 22 131 22C102.281 22 79 45.2812 79 74C79 102.719 102.281 126 131 126Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.423 94.5065L105.544 79.6572L122.515 96.6278L107.665 98.7491L103.423 94.5065Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.485 45.7154C142.609 42.5913 147.674 42.5913 150.798 45.7154L156.455 51.3723C159.58 54.4965 159.58 59.5618 156.455 62.686L153.627 65.5144L136.656 48.5439L139.485 45.7154Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.655,
    y: 48.5439,
    width: 24,
    height: 44,
    transform: "rotate(45 136.655 48.5439)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.716 99.4556L103.423 94.5059L107.665 98.7485L102.716 99.4556Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.716,
    y: 90.9707,
    width: 12,
    height: 2,
    transform: "rotate(45 102.716 90.9707)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.364,
    y: 47.8369,
    width: 24,
    height: 2,
    transform: "rotate(45 137.364 47.8369)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.958,
    y: 78.2422,
    width: 24,
    height: 2,
    transform: "rotate(45 106.958 78.2422)",
    fill: "#D89FEE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2817 78.9101C61.2108 83.4842 43.664 73.3536 39.0899 56.2826C34.5158 39.2117 44.6464 21.6649 61.7173 17.0908C78.7882 12.5167 96.335 22.6473 100.909 39.7182C105.483 56.7891 95.3527 74.3359 78.2817 78.9101Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6583 55.7954L86.0322 47.3066L78.6476 60.0972L87.8121 58.993L89.6583 55.7954Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.452 32.5406C58.0973 31.1812 55.0864 31.9879 53.7269 34.3426L51.2654 38.6061C49.9059 40.9608 50.7127 43.9717 53.0674 45.3312L55.1991 46.5619L62.5837 33.7714L60.452 32.5406Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.7692,
    height: 27.0769,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 62.583 33.7715)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8669 58.6255L89.6582 55.7959L87.812 58.9935L90.8669 58.6255Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.38462,
    height: 1.23077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 89.5146 53.584)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.7692,
    height: 1.23077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 62.0479 33.4619)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.7692,
    height: 1.23077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 84.9658 46.6934)",
    fill: "#D89FEE"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 28L239.5 18.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 19.5L21 25",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 123L39.5 114",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9730"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.434,
    y: 72.79,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(12 198.434 72.79)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9730"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 22,
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    transform: "matrix(-0.965926 0.258819 0.258819 0.965926 92.627 8.80859)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyJournaling);
export default __webpack_public_path__ + "static/media/daily-journaling.745ce02e3e694f4bcbbd9b2e7012a625.svg";
export { ForwardRef as ReactComponent };